var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageChatCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-chat-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solid"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28675 44.1742C3.28675 34.6625 10.8296 26.8408 20.2692 26.8408C29.7089 26.8408 37.2517 34.6625 37.2517 44.1742C37.2517 53.6858 29.7089 61.5075 20.2692 61.5075C18.3288 61.5075 16.4596 61.1742 14.7169 60.5592C14.4289 60.4575 14.2502 60.3946 14.1192 60.3513C14.0954 60.3434 14.0759 60.3371 14.0604 60.3322L14.0459 60.3338C13.9544 60.3439 13.8297 60.3607 13.5986 60.3923L5.6125 61.483C4.74836 61.601 3.88111 61.289 3.29023 60.6474C2.69935 60.0059 2.45952 59.116 2.64803 58.2645L4.27828 50.9C4.33493 50.6441 4.36524 50.506 4.38471 50.4044C4.38582 50.3987 4.38775 50.3884 4.38775 50.3884C4.3829 50.3715 4.37677 50.3506 4.3691 50.3252C4.32519 50.1797 4.2606 49.9815 4.15562 49.6602C3.59113 47.9322 3.28675 46.0865 3.28675 44.1742Z",
    fill: "url(#paint0_linear_2718_95465)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6451 22.5011C15.7186 21.856 17.9288 21.5075 20.2326 21.5075C32.8018 21.5075 42.5853 31.8826 42.5853 44.1741C42.5853 46.3438 42.2804 48.4539 41.7092 50.4577C43.1546 50.198 44.5564 49.8103 45.9018 49.3064C46.0915 49.2353 46.2809 49.1627 46.4726 49.097C46.6274 49.115 46.7814 49.1391 46.9356 49.1617L55.5034 50.4176C55.9078 50.477 56.3668 50.5445 56.7669 50.5672C57.2099 50.5924 57.8984 50.5897 58.6281 50.2759C59.5393 49.8841 60.2725 49.1677 60.6852 48.2657C61.0157 47.5434 61.0343 46.8552 61.0194 46.4117C61.0058 46.011 60.949 45.5507 60.8989 45.1449L59.8162 36.3505C59.7881 36.1219 59.7735 36.0018 59.7651 35.9138C59.8119 35.7211 59.8999 35.5347 59.9704 35.3499C60.9805 32.7019 61.5324 29.8324 61.5324 26.8408C61.5324 13.5695 50.7078 2.84082 37.392 2.84082C25.5632 2.84082 15.7004 11.307 13.6451 22.5011Z",
    fill: "url(#paint1_linear_2718_95465)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2718_95465",
    x1: 2.58496,
    y1: 61.5075,
    x2: 61.251,
    y2: 2.56078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3377E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#23BFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2718_95465",
    x1: 2.58496,
    y1: 61.5075,
    x2: 61.251,
    y2: 2.56078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3377E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#23BFEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageChatCircle);
export default __webpack_public_path__ + "static/media/message-chat-circle.426fd217818f38abf6cf52202b2fe67f.svg";
export { ForwardRef as ReactComponent };